import { ButtonHTMLAttributes, FC, PropsWithChildren } from 'react';

import S from './Button.styled';

interface IButtonProps
  extends PropsWithChildren,
    ButtonHTMLAttributes<HTMLButtonElement> {}

export const Button: FC<IButtonProps> = ({ children, ...props }) => {
  return (
    <S.Button type="button" {...props}>
      {children}
    </S.Button>
  );
};
